export default "/images/arrow-up.svg?70d8ca827d1640720ed80c86fd48dcfa";